import axios from "../http";
import bizConstant from "../constants/biz-constant";
import rongchuangConstant from "@/api-service/constants/rongchuang-constant";

const url = "/mall/wx/movie/apiProxy";

const request = {
  getMovieRepeat(movieName, opiId) {
    return axios.get('/mall/wx/movie/get-movie-repeat', { params: { movieName, opiId } });
  },

  mv_get_jsapi_ticket(url) {
    const formData = new FormData()
    formData.append('url', url)
    return axios.post('/v5/get-jsapi-ticket', formData)
  },

  createPartnerOrder(data = {}) {
    data.method = rongchuangConstant.REQ_PARTNER_ORDER_CREATE;

    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getMovieList(data = {}) {
    let url = bizConstant.REQ_MOVIE_CITY_LIST;

    return axios.request({
      url,
      data
    });
  },

  getBannerList(data = {}) {
    let url = bizConstant.REQ_BANNER_LIST;

    return axios.request({
      url,
      data
    });
  },

  getMovieDetail(data = {}) {
    data.method = bizConstant.REQ_MOVIE_DETAIL;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getMovieActorImage(data = {}) {
    data.method = bizConstant.REQ_MOVIE_ACTOR_IMAGE_GET;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getHotMovieList(data = {}) {
    data.method = bizConstant.REQ_MOVIE_LIST_HOT;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getFutureMovieList(data = {}) {
    data.method = bizConstant.REQ_MOVIE_LIST_FUTURE;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getCinemaList(data = {}) {
    data.method = bizConstant.REQ_MOVIE_CINEMA_LIST;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  m_city_list(data = {}) {
    data.method = bizConstant.REQ_MOVIE_CITY_LIST;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getCountyList(data = {}) {
    data.method = bizConstant.REQ_MOVIE_COUNTY_LIST;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getCinemaDetail(data = {}) {
    data.method = bizConstant.REQ_MOVIE_CINEMA_DETAIL;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getMovieCinemaDateList(data = {}) {
    data.method = bizConstant.REQ_MOVIE_CINEMA_DATE_LIST;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  // movie.opi.list
  movie_opi_list(data = {}) {
    data.method = bizConstant.REQ_MOVIE_SESSION_LIST;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getMovieCinemaSeat(data = {}) {
    data.method = bizConstant.REQ_MOVIE_CINEMA_SEAT;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  validate_selected_seat_list(data = {}) {
    data.method = bizConstant.REQ_MOVIE_CINEMA_SEAT_VALIDATE;
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  createOrder(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_CREATE;
    return axios.request({
      url,
      data
    });
  },

  getOrder(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_GET;
    return axios.request({
      url,
      data
    });
  },

  getOrderRemaining(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_REMAINING;
    return axios.request({
      url,
      data
    });
  },

  getUnPaidOrder(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_UNPAID_GET;
    return axios.request({
      url,
      data
    });
  },

  getMemberOrderCouponList(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_COUPON_LIST;
    return axios.request({
      url,
      data
    });
  },

  modifyCouponByOrder(data = {}) {
    let url = bizConstant.REQ_MEMBER_COUPON_ORDER_MODIFY;
    return axios.request({
      url,
      data
    });
  },

  modifyUseVip(data = {}) {
    let url = bizConstant.REQ_MEMBER_VIP_ORDER_MODIFY;
    return axios.request({
      url,
      data
    });
  },

  getMemberCouponList(data = {}) {
    let url = bizConstant.REQ_MEMBER_COUPON_LIST;
    return axios.request({
      url,
      data
    });
  },

  getMemberVipList(data = {}) {
    let url = bizConstant.REQ_MEMBER_COUPON_VIP_LIST;
    return axios.request({
      url,
      data
    });
  },

  getMemberOrderList(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_LIST;
    return axios.request({
      url,
      data
    });
  },

  cancelMemberOrder(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_CANCEL;
    return axios.request({
      url,
      data
    });
  },

  deleteMemberOrder(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_DELETE;
    return axios.request({
      url,
      data
    });
  },

  getCouponInfo(data = {}) {
    let url = bizConstant.REQ_MEMBER_COUPON_GET;
    return axios.request({
      url,
      data
    });
  },

  bindCoupon(data = {}) {
    let url = bizConstant.REQ_MEMBER_COUPON_ADD;
    return axios.request({
      url,
      data
    });
  },

  bindVip(data = {}) {
    let url = bizConstant.REQ_MEMBER_VIP_ADD;
    return axios.request({
      url,
      data
    });
  },

  getOrderDetail(data = {}) {
    let url = bizConstant.REQ_MEMBER_ORDER_DETAIL_GET;
    return axios.request({
      url,
      data
    });
  }
};

export default request;
